import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { TruthSection } from './components/TruthSection';
import { ProgramIntro } from './components/ProgramIntro';
import { Results } from './components/Results';
import { Curriculum } from './components/Curriculum';
import { WorkGallery } from './components/WorkGallery';
import { Testimonials } from './components/Testimonials';
import { InstructorBio } from './components/InstructorBio';
import { HowItWorks } from './components/HowItWorks';
import { PricingSection } from './components/PricingSection';
import { Guarantee } from './components/Guarantee';
import { FinalClose } from './components/FinalClose';
import { SalesNotifications } from './components/shared/SalesNotifications';
export function App() {
  return <main className="min-h-screen w-full bg-cream font-sans text-warm-dark overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <TruthSection data-id="element-3" />
      <ProgramIntro data-id="element-4" />
      <Results data-id="element-5" />
      <Curriculum data-id="element-6" />
      <WorkGallery data-id="element-7" />
      <Testimonials data-id="element-8" />
      <InstructorBio data-id="element-9" />
      <HowItWorks data-id="element-10" />
      <PricingSection data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FinalClose data-id="element-13" />
      <SalesNotifications data-id="element-14" />
    </main>;
}